export const GET_ARAM_BALANCE_REQUEST = 'balance/GET_ARAM_BALANCE_REQUEST';
export const GET_ARAM_BALANCE_SUCCESS = 'balance/GET_ARAM_BALANCE_SUCCESS';
export const GET_ARAM_BALANCE_FAILURE = 'balance/GET_ARAM_BALANCE_FAILURE';
